import { Logs, Notification, Waiting } from '@xbotvn/react-ui/components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { graphQLCaller } from '../../libs/backend';

function UsersLogs({ onClose, type, id }) {
  const unitId = useSelector(({ user }) => user?.unit?.id ?? '');

  const [logs, setLogs] = useState();

  useEffect(() => {
    let cancelled = false;

    (async () => {
      if (!unitId) {
        onClose();
        return;
      }
      try {
        const results = await graphQLCaller(
          'logs',
          `{
          logs(unitID: "${unitId}", type: "${type}", ref: "${id}") {
            user
            message
            time
          }
        }`,
        );
        if (cancelled) return;
        setLogs(
          (results?.logs ?? []).map((log) => ({
            ...log,
            time: log.time ? parseFloat(log.time) : '',
          })),
        );
      } catch ({ message }) {
        if (!cancelled) {
          Notification.error(message);
          onClose();
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [unitId, onClose, type, id]);

  return logs ? <Logs open onClose={onClose} logs={logs} /> : <Waiting />;
}

export default UsersLogs;
